(function() {
	'use strict';

	angular.module('onboarding.common')
		.directive('usurp', [
			function() {
				
				return {
					restrict: 'E',
					controller: 'usurpCtrl',
					controllerAs: 'ctrl',
					templateUrl: '/app/common/usurp/usurp.template.html'
				};
			}
		])
		.constant('USURP_LS', {
			TIMESTAMP : 'usurp_timestamp',
			IS_FROM_LOGIN : 'usurp_from_login'
		});
})();
